'use client'

import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import { roomQueries } from '@/entities/room'
import { cn, useIsTablet } from '@/shared/lib'
import { Spinner } from '@/shared/ui'

import { MobileRecentRoomItem } from './item.mobile'

type Props = {
  className?: string
}

export const MobileRecentRoomList = ({ className }: Props) => {
  const t = useTranslations('search_panel')

  const isTablet = useIsTablet()

  const { isLoading, data: recentRooms } = useQuery({
    ...roomQueries.recentViewedRooms(),
  })

  const hasRecentRooms = recentRooms && recentRooms.length > 0

  if (!isLoading && !hasRecentRooms) return null

  return (
    <section className={cn(className)}>
      <h2 className="typo-headline3 mb-4 font-semibold text-black">
        {t('recent_room.title')}
      </h2>
      {isLoading ? (
        <div
          className={cn(
            'relative flex h-25 justify-center',
            isTablet && 'h-50',
          )}
        >
          <Spinner />
        </div>
      ) : (
        <ul className="md:grid md:grid-cols-2 md:gap-x-10">
          {recentRooms?.map((room, index, array) => {
            const isFirstRow = index < 2
            const isLastRow =
              index >= array.length - (array.length % 2 === 0 ? 2 : 1)

            return (
              <li
                key={room.rid}
                className={cn(
                  'group border-b border-gray-100 last:border-none',
                  isLastRow && 'md:border-none',
                )}
              >
                <MobileRecentRoomItem
                  href={`/guest/room/${room.rid}`}
                  room={room}
                  className={cn(
                    'group-first:pt-0 group-last:pb-0',
                    isLastRow && 'md:pb-0',
                    isFirstRow && 'md:pt-0',
                  )}
                />
              </li>
            )
          })}
        </ul>
      )}
    </section>
  )
}
